if (!customElements.get('hero-slideshow')) {
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.trackHeaderTopSections();

      this.swiperEl = this.querySelector('[data-hs-swiper]');
      this.slideCount = this.querySelectorAll('.swiper-slide').length;
      if (!this.swiperEl || this.slideCount < 2) return;

      this.autoplayAllowed =
        this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);

      this.initSwiper();
    }

    disconnectedCallback() {
      clearTimeout(this.swiperRetry);
      if (this.topSectionsObserver) this.topSectionsObserver.disconnect();
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('click', this.onClick);
      if (this.swiperEl && this.swiperEl.swiper) this.swiperEl.swiper.destroy(true, true);
    }

    trackHeaderTopSections() {
      const sections = document.querySelectorAll(theme.headerTopSectionsSelector);
      if (!sections.length) return;

      const sync = () => {
        let height = 0;
        sections.forEach((el) => { height += el.clientHeight; });
        document.documentElement.style.setProperty(
          '--header-top-sections-height',
          `${Math.ceil(height)}px`
        );
      };

      sync();
      this.topSectionsObserver = new ResizeObserver(sync);
      sections.forEach((el) => this.topSectionsObserver.observe(el));
    }

    initSwiper() {
      if (!this.swiperEl || this.swiperEl.swiper) return;

      if (typeof Swiper === 'undefined') {
        this.swiperRetry = setTimeout(() => this.initSwiper(), 100);
        return;
      }

      const delay = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;

      const swiper = new Swiper(this.swiperEl, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        simulateTouch: false,
        speed: parseInt(this.dataset.fadeSpeed, 10) || 600,
        slidesPerView: 1,
        autoplay: this.autoplayAllowed
          ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
      });

      swiper.on('slideChange', () => this.syncCounter(swiper));
      swiper.on('slideChangeTransitionEnd', () => this.syncInert());
      this.syncCounter(swiper);
      this.syncInert();
      this.observeSelf(swiper);
    }

    syncCounter(swiper) {
      this.querySelectorAll('[data-hs-counter]').forEach((el) => {
        el.textContent = swiper.realIndex + 1;
      });
    }

    syncInert() {
      this.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.inert = !slide.classList.contains('swiper-slide-active');
      });
    }

    observeSelf(swiper) {
      if (!this.autoplayAllowed || !('IntersectionObserver' in window) || !swiper.autoplay) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            if (this.autoplayAllowed) swiper.autoplay.start();
          } else {
            swiper.autoplay.stop();
          }
        },
        { threshold: 0.2 }
      );

      this.observer.observe(this);
    }

    onClick(evt) {
      if (!evt.target.closest('[data-hs-next]')) return;
      if (this.swiperEl.swiper) this.swiperEl.swiper.slideNext();
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);
}

document.addEventListener('shopify:block:select', (evt) => {
  const hero = evt.target.closest('hero-slideshow');
  if (!hero) return;

  const swiperEl = hero.querySelector('[data-hs-swiper]');
  if (!swiperEl || !swiperEl.swiper) return;

  const index = parseInt(evt.target.dataset.hsIndex, 10);
  if (!isNaN(index)) swiperEl.swiper.slideToLoop(index);
  if (swiperEl.swiper.autoplay) swiperEl.swiper.autoplay.stop();
});

document.addEventListener('shopify:block:deselect', (evt) => {
  const hero = evt.target.closest('hero-slideshow');
  if (!hero) return;

  const swiperEl = hero.querySelector('[data-hs-swiper]');
  if (!swiperEl || !swiperEl.swiper || !swiperEl.swiper.autoplay) return;
  if (hero.autoplayAllowed) swiperEl.swiper.autoplay.start();
});
